import React from 'react';
import { ISVGType } from './SVGType';

const CloseSVG = (props: ISVGType) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" className={className}>
      <mask id="mask0_1484_3975" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="28"
            height="28">
        <rect width="28" height="28" fill="white"/>
      </mask>
      <g mask="url(#mask0_1484_3975)">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M20.35 22.1756C20.0338 22.1756 19.7588 22.0587 19.525 21.825L13.9999 16.2998L8.47478 21.825C8.24104 22.0587 7.96605 22.1756 7.64982 22.1756C7.33359 22.1756 7.0586 22.0587 6.82486 21.825C6.59112 21.5912 6.47426 21.3162 6.47426 21C6.47426 20.6838 6.59112 20.4088 6.82486 20.1751L12.35 14.6499L6.3257 8.62564C6.09197 8.39191 5.9751 8.11692 5.9751 7.80069C5.9751 7.48445 6.09197 7.20947 6.3257 6.97573C6.55944 6.74199 6.83443 6.62512 7.15066 6.62512C7.4669 6.62512 7.74188 6.74199 7.97562 6.97573L13.9999 13L20.0242 6.97573C20.2579 6.74199 20.5329 6.62512 20.8491 6.62512C21.1654 6.62512 21.4404 6.74199 21.6741 6.97573C21.9078 7.20947 22.0247 7.48445 22.0247 7.80069C22.0247 8.11692 21.9078 8.39191 21.6741 8.62564L15.6498 14.6499L21.1749 20.1751C21.4087 20.4088 21.5256 20.6838 21.5256 21C21.5256 21.3162 21.4087 21.5912 21.1749 21.825C20.9412 22.0587 20.6662 22.1756 20.35 22.1756Z"
              fill="#1C1C1C"/>
      </g>
    </svg>
  );
};

export default CloseSVG;
